import React, { useState,useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { API_ENDPOINTS } from './apiConfig';
import { useAuth } from "./AuthContext";
import './Signup.css'; // Custom CSS for animation 


function ProfileImageUpload() {
  const [files, setFiles] = useState([]);
  const [previewUrls, setPreviewUrls] = useState([]);
  const [errors, setErrors] = useState([]);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [animateArrow, setAnimateArrow] = useState(false);
  const navigate = useNavigate();
  const { token } = useAuth();

  const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
  const maxSize = 4 * 1024 * 1024; // 2MB
  const maxFiles = 10;


  useEffect(() => {

      if (!token || token.trim() === '') {
             navigate('/login');
          }
  window.scrollTo({ top: 0, behavior: 'smooth' });
}, []);

  const handleFileChange = (e) => {
    setAnimateArrow(true)
    const selectedFiles = Array.from(e.target.files);
    const newErrors = [];

    if (selectedFiles.length + files.length > maxFiles) {
      newErrors.push(`You can upload up to ${maxFiles} images.`);
    }

    const validFiles = selectedFiles.filter((file) => {
      if (!allowedTypes.includes(file.type)) {
        newErrors.push(`${file.name} is not a valid image type.`);
         setTimeout(() => setAnimateArrow(false), 100);
        return false;
      }
      if (file.size > maxSize) {
        newErrors.push(`${file.name} exceeds 4MB size limit.`);
         setTimeout(() => setAnimateArrow(false), 100);
        return false;
      }
      return true;
    });

    if (newErrors.length > 0) {
      setErrors(newErrors);
       setTimeout(() => setAnimateArrow(false), 100);
      return;
    }

    setFiles((prev) => [...prev, ...validFiles]);

    const newPreviews = validFiles.map((file) => URL.createObjectURL(file));
    setPreviewUrls((prev) => [...prev, ...newPreviews]);

    setErrors([]); // Clear errors on new valid selection
  };

  const handleRemoveFile = (index) => {
    const updatedFiles = [...files];
    const updatedPreviews = [...previewUrls];

    updatedFiles.splice(index, 1);
    updatedPreviews.splice(index, 1);

    setFiles(updatedFiles);
    setPreviewUrls(updatedPreviews);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors([]);
    setMessage('');
    setLoading(true);

    if (files.length === 0) {
      setErrors(['Please select at least one image file.']);
      setLoading(false);
       setTimeout(() => setAnimateArrow(false), 100);
      return;
    }

    const formData = new FormData();
    files.forEach((file) => {
      formData.append('photos', file); // match your API
    });

    try {
      const res = await axios.post(API_ENDPOINTS.PHOTOS, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          token: token
        },
      });

      const { result, user, errors: serverErrors } = res.data;

      if (result === 1) {
        setMessage('Profile images uploaded successfully!');
        setTimeout(() => {
          navigate('/Search');
        }, 1500);
      } else {
        const allMessages = [];

        if (Array.isArray(serverErrors)) {
          allMessages.push(...serverErrors);
        }
        if (user !== undefined) {
          allMessages.push(`Error: ${user}`);
        }

        setErrors(allMessages.length ? allMessages : ['Upload failed.']);
      }
    } catch (err) {
      const status = err.response?.status;
      const data = err.response?.data;

      if (status === 400 && Array.isArray(data?.errors)) {
        setErrors(data.errors);
      } else {
        setErrors(['Server error. Please try again later.']);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="d-flex flex-column min-vh-100"
      style={{
        background: 'linear-gradient(135deg, #ffe0f0, #d0e8ff)',
        paddingTop: '4rem',
      }}
    >
      <div style={{ maxWidth: 480, width: '100%', margin: '0 auto' }}>
       
          <div className="text-center mb-4">     
          <span className="badge bg-secondary">Step 4 of 4</span>
          <h5 className="mt-2 wedding-heading">
            Upload Your Pictures 📷
          </h5>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label text-muted">Select Images (Max 10)</label>
            <input
              type="file"
              className="form-control"
              accept={allowedTypes.join(',')}
              multiple
              onChange={handleFileChange}
            />
          </div>

          {previewUrls.length > 0 && (
            <div className="mb-3">
              <label className="form-label text-muted">Preview:</label>
              <div className="d-flex flex-wrap gap-2">
                {previewUrls.map((url, index) => (
                  <div key={index} style={{ position: 'relative' }}>
                    <img
                      src={url}
                      alt={`Preview ${index + 1}`}
                      style={{
                        width: '100px',
                        height: '100px',
                        objectFit: 'cover',
                        borderRadius: '8px',
                        border: '1px solid #ccc',
                      }}
                    />
                    <button
                      type="button"
                      onClick={() => handleRemoveFile(index)}
                      style={{
                        position: 'absolute',
                        top: '-8px',
                        right: '-8px',
                        backgroundColor: '#ff69b4',
                        color: 'white',
                        border: 'none',
                        borderRadius: '50%',
                        width: '24px',
                        height: '24px',
                        cursor: 'pointer',
                        fontSize: '14px',
                      }}
                    >
                      &times;
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}


   <button
        type="submit"
        className="btn w-100 mt-3 d-flex justify-content-between align-items-center px-3"
        style={{ backgroundColor: '#ff69b4', color: 'white', overflow: 'hidden' }}
        disabled={loading}
      >
        <span>{loading ? 'Uploading...' : 'Upload Images'}</span>

        <i
          className={`bi bi-arrow-right-circle-fill ${
            animateArrow ? 'move-arrow' : ''
          }`}
          style={{ fontSize: '1.4rem' }}
        ></i>
      </button>


        </form>

        {message && (
          <div className="alert alert-success mt-3" style={{ whiteSpace: 'pre-line' }}>
            {message}
          </div>
        )}

        {errors.length > 0 && (
          <div className="alert alert-danger mt-3" style={{ backgroundColor: '#ffe0e0', color: '#cc0000' }}>
            <ul className="mb-0">{errors.map((e, i) => <li key={i}>{e}</li>)}</ul>
          </div>
        )}

        <div className="text-center mt-4">
          <small className="text-muted">
            After uploading, you can view them in your profile.
          </small>
        </div>
      </div>
    </div>
  );
}

export default ProfileImageUpload;
